'use client';

import { VelocityClient } from '@velocity-exchange/sdk';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import useVelocityClientIsReady from './useVelocityClientIsReady';

const useVelocityClient = (): VelocityClient | undefined => {
	const isVelocityClientReady = useVelocityClientIsReady();
	const velocityClient = useVelocityStore((s) => s.velocityClient?.client);

	return isVelocityClientReady ? velocityClient : undefined;
};

export default useVelocityClient;
